module.exports = __webpack_public_path__ + "static/img/7.76cfb4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/7.png
// module id = pB2E
// module chunks = 1